import React, {Component} from 'react';
import {Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {connect} from "react-redux";

import IngredientData from "../../data/IngredientData";
import IngredientDialog from "../../components/inventories/IngredientDialog";
import CustomDivider from '../../components/extras/CustomDivider';
import IngredientCurrentStockModal from "../../components/inventories/IngredientCurrentStockModal";
import {openModalIngredientStock} from "../../actions/ModalIngredientStockActions";
import DynamicTable from "../../components/extras/DynamicTable";
import {ingredientDialog} from "../../actions/IngredientDialogAction";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import {selectIngredient} from "../../actions/IngredientSelectAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import {showToast} from "../../actions/ToastAction";
import StockIngredient from "../../components/inventories/StockIngredient";

class Ingredients extends Component {
    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Ingrediente', 'Medida', 'Precio', 'Control de Inventarios', 'Acciones'],
                name: 'Ingrediente',
                title: 'Ingredientes',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'ingredients',
                values: ['id', 'name', 'get_unit_display', 'price', 'stock'],
                money_fields: ['price'],
                component_fields: [{stock:StockIngredient}],
                id: 'table_ingredients'
            },
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ingredient_select && nextProps.ingredient_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.ingredient_select);
        }
    }

    async delete(id) {
        IngredientData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Ingrediente Borrado!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.ingredientDialog({open:true, ingredient:{id:null, name:'', price: 0, stock: false, unit:null}});
        }else if(response.event === 'edit'){
            this.props.ingredientDialog({open:true, ingredient:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }else if(response.event === 'stock'){
            this.props.openModalIngredientStock({is_open:true, data:response.data})
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Ingredientes | Inventarios - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Ingredientes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <IngredientDialog/>
                <QuestionDialog ref="deleteDialog" message="Borrar este ingrediente" callbackConfirm={this.delete}/>
                <IngredientCurrentStockModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ingredient_select: state.get('ingredient_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        openModalIngredientStock(modal){
            dispatch(openModalIngredientStock(modal))
        },
        ingredientDialog(data){
            dispatch(ingredientDialog(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        selectIngredient(data){
            dispatch(selectIngredient(data))
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ingredients)




// WEBPACK FOOTER //
// ./src/containers/inventories/Ingredients.js